// extracted by mini-css-extract-plugin
export var numpadContainer = "_pi-1";
export var phoneButton = "_pi-0";